import styled from 'styled-components';
import { Panel, SectionLabel, Avatar } from '@/ui';
import type { Community } from '@/core/models/community';

const List = styled.ul`list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 10px;`;
const Row = styled.li`display: flex; align-items: center; gap: 10px;`;
const Name = styled.span`font-family: ${({ theme }) => theme.font.body}; font-weight: 600; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textPrimary};`;

export function ModeratorsPanel({ community }: { community: Community }) {
  return (
    <Panel>
      <SectionLabel as="h2">Moderators</SectionLabel>
      <List>
        {community.moderators.map((m) => (
          <Row key={m.name}>
            <Avatar name={m.name} size={32} />
            <Name>{m.name}</Name>
          </Row>
        ))}
      </List>
    </Panel>
  );
}
